export const splitAction = (action: string | undefined) => {
  let resource: string | undefined;
  let stageValue: string | undefined;

  if (action?.length) {
    [resource, stageValue] = action.split(":");
  }

  return { resource, stageValue };
};
